export default __webpack_public_path__ + "static/char-30-f8ce4618fd593d5e87365ed01776e704.gif";